import { BillingMethodEnum } from "@enums/billingMethodEnum.enum";
import { UserDto } from "./userDto";

export class PaymentReceiptDto {
  Id: number
  stripeChargeId: string
  customerId: number
  userId: string
  amount: number
  amountCaptured: number
  amountRefunded: number
  receiptDescription: string
  receiptCreatedDate: Date
  applicationFee: number
  stripeCustomerId: string
  stripeInvoiceId: string
  paymentIntentId: string
  receiptURL: string
  billingMethod: BillingMethodEnum
  receiptTypeText: string

  userFullName: string
  customerFullName: string
}